/*
 * @Author: your name
 * @Date: 2021-07-20 17:33:21
 * @LastEditTime: 2022-03-18 17:16:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \distc:\Users\fc\Desktop\ssms-pc\src\main.js
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import 'babel-polyfill';
import Vue from 'vue';
import vuexRouterSync from 'vuex-router-sync';
import ElementUI from 'element-ui';
// import { sentry } from 'fengche-utils';
// eslint-disable-next-line
import './assets/styles/theme/index.css';
import App from './App';
import router from './router';
import store from './store';
import ajax from './http/ajax';
import filters from './utils/filters';
import NativeStorage from './utils/storage';

// import { APP_VERSION } from './http/helpers';

// 用fc-input-number全局组件替换el-input-number组件: el-input-number输入框空时值为undefined，fc-input-number输入框空时值为0,再根据min跟max处理,其余用法一致
import fcInputNumber from './components/FcInputNumber';

Vue.use(fcInputNumber);

// if (process.env.API_ENV === 'release') {
//     const option = {
//         dsn: '//1260345e50734f90ad386657268960ca@sentry.carisok.cn/8',
//         release: APP_VERSION,
//         environment: process.env.NODE_ENV,
//     };
//     const Sentry = sentry.getInstance(Vue, option);
//     Vue.prototype.$sentry = Sentry;
// }

Vue.config.productionTip = false;
vuexRouterSync.sync(store, router);

Vue.$ajax = ajax;
Vue.$storage = new NativeStorage();
// Vue.prototype.$message = Message;

filters(Vue);
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>',
});




// WEBPACK FOOTER //
// ./src/main.js